import styled, { StyledComponent, css } from 'styled-components';

export const Wrapper: StyledComponent<
  'div',
  any,
  { active: boolean; disabled?: boolean }
> = styled.div<{ active: boolean; disabled?: boolean }>`
  border: 1px solid ${(props) => (props.active ? '#0046FF' : 'rgba(0, 0, 0, 0.15)')};
  border-radius: 4px;
  margin-bottom: 16px;
  position: relative;

  &::after {
    ${({ disabled }) => {
      if (disabled) {
        return css`
          content: '';
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          cursor: not-allowed;
        `;
      }
      return;
    }}
  }
`;

export const TopBar = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 12px 16px;

  background: #f7f7f7;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
`;

export const TopBarLeft = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Prefix: StyledComponent<
  'div',
  any,
  { type?: 'Group' | 'group' | 'Rule' | 'rule' | undefined }
> = styled.div<{ type?: 'Group' | 'group' | 'Rule' | 'rule' }>`
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 12px;
  width: ${(props) => (props.type === 'Group' || props.type === 'group' ? 'fit-content' : '78px')};
  margin-right: ${(props) => (props.type === 'Group' || props.type === 'group' ? '16px' : '0')};
`;

export const InputBox = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

export const Operator = styled.div`
  padding: 0 8px 0 6px;
`;

export const EventName: StyledComponent<'div', any, { active?: boolean }> = styled.div<{
  active?: boolean;
}>`
  letter-spacing: -0.01em;
  color: ${(props) => (props.active ? '#0046FF' : 'rgba(0, 0, 0, 0.65)')};
`;

export const Main: StyledComponent<'div', any, { showPadding?: boolean }> = styled.div<{
  showPadding?: boolean;
}>`
  padding: ${(props) => (props.showPadding === false ? '0' : '0 12px 0 76px')};
`;

export const AddRuleButtonWrapper = styled.div`
  height: 48px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  padding-left: 34px;
  border-top: 2px solid rgba(0, 0, 0, 0.06);
`;

export const RuleList: StyledComponent<'div', any, { isDraggingOver?: boolean }> = styled.div<{
  isDraggingOver?: boolean;
}>`
  transition: background-color 0.2s ease;
  background-color: ${(props) => (props.isDraggingOver ? 'white' : 'white')};
  min-height: 5px;
`;
